import { Component, OnInit } from "@angular/core";
import { AccountsService } from "./accounts.service";

@Component({
  selector: "create-account",
  template: require('./createaccount.component.html'),
  styles: [require('./createaccount.component.scss')]
})
export class CreateAccountComponent implements OnInit {
  account: any = {
    active: false,
    project_ids: [],
    company_id: "",
    mood_explorer: false
  };
  users: any[] = [];
  sent: boolean = false;
  activePanels: string[] = ["details", "users"];
  submitted: boolean = false;
  employers: any[];
  projects: any[] = [];
  projectId: string;

  constructor(private service: AccountsService) {}

  ngOnInit() {
    this.service.getEmployers().subscribe((employers) => {
      this.employers = employers;
    });
    this.getProjects();
    this.addUser();
  }

  getProjects() {
    this.service
      .getProjects()
      .subscribe((projects) => (this.projects = projects));
  }

  getProjectName(id: string): string {
    return this.projects.filter((item) => {
      return item.id === id;
    })[0].name;
  }

  removeListItem(field: string, id: string) {
    let array = this.account[field];
    let index = array.indexOf(id);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  addProject(projectId: string) {
    if (projectId) {
      this.account.project_ids.push(projectId);
      this.projectId = null;
    }
  }

  selectedProjects() {
    return this.projects.filter((it) => {
      return this.account.project_ids.indexOf(it.id) > -1;
    });
  }

  addUser() {
    this.users.push({ active: false, name: "", email: "" });
  }

  isValid(): boolean {
    return (
      !this.sent &&
      this.account.project_ids.length > 0 &&
      this.account.company_id !== ""
    );
  }

  onSubmit() {
    this.activePanels = [];
    if (!this.sent) {
      this.sent = true;
      this.service.createAccount(this.account, this.users).subscribe(
        (account) => {
          this.back();
        },
        (error) => {
          this.sent = false;
          setTimeout(() => {
            this.activePanels = ["details", "users"];
          }, 1);
        }
      );
    }
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/createaccount.component.ts